export default __webpack_public_path__ + "static/media/heroGif_600.6058cf4a.gif";